<div class="pt-2 parent-scroll">
    <cmps-wait-status *ngIf="state?.pending?.reload"></cmps-wait-status>

    <ng-container
        [formGroup]="_form.form"
        *ngIf="!state?.pending?.reload"
    >
        <cmps-alert
            class="mb-3"
            [dismissible]="false"
            *ngIf="state?.isReadOnly"
        >
            <div class="d-flex align-items-center px-5">
                {{
                    _i18n._9788_THIS_COMMITMENT_IS_BEING_DISPUTED__IT_IS_THE_ORIGINAL
                        | translate
                }}
            </div>
        </cmps-alert>

        <cmps-alert
            class="mb-3"
            [dismissible]="state?.approvalAlertInfo?.dismissible"
            [borderColor]="state?.approvalAlertInfo?.borderColor"
            [backgroundColor]="state?.approvalAlertInfo?.backgroundColor"
            (closed)="_showApprovalAlert = false"
            *ngIf="_showApprovalAlert"
        >
            <!--using tags and util classes rather than creating classes for the moment-->
            <div class="d-flex align-items-center justify-content-between px-5">
                <div>
                    <span
                        >{{
                            state?.approvalAlertInfo?.messagePrefix | translate
                        }}
                        {{
                            state?.approvalAlertInfo?.participant | translate
                        }}</span
                    >
                </div>
                <div
                    class="d-flex"
                    *ngIf="state?.approvalAlertInfo?.showActions"
                >
                    <div class="px-2">
                        <button
                            class="cmps-outline-button--sm cmps-outline-button--no-bg"
                            cmpsOutlineButton
                            [disabled]="_pending"
                            (click)="_onViewSummaryClick()"
                        >
                            <span cmpsOutlineButtonLabel>
                                {{
                                    (state?.commitment?.statusId ===
                                    _CoachingEventStatus.UPDATING
                                        ? _i18n._9759_VIEW_UPDATES_SUMMARY
                                        : _i18n._9768_VIEW_SUMMARY
                                    ) | translate
                                }}
                            </span>
                        </button>
                    </div>
                    <div class="px-2">
                        <button
                            class="cmps-outline-button--sm cmps-outline-button--no-bg"
                            cmpsOutlineButton
                            [disabled]="_pending"
                            (click)="_onAcceptAllChangesClick()"
                        >
                            <span cmpsOutlineButtonLabel>{{
                                _i18n._9760_ACCEPT_ALL_CHANGES | translate
                            }}</span>
                        </button>
                    </div>
                </div>
            </div>
        </cmps-alert>
        <cmps-alert
            class="mb-3"
            [dismissible]="false"
            [borderColor]="state?.mirrorCopyAlertInfo?.borderColor"
            [backgroundColor]="state?.mirrorCopyAlertInfo?.backgroundColor"
            *ngIf="state?.mirrorCopyAlertInfo"
        >
            <!--using tags and util classes rather than creating classes for the moment-->
            <div class="d-flex align-items-center justify-content-between px-5">
                <div>
                    <span>{{
                        state?.mirrorCopyAlertInfo?.messagePrefix | translate
                    }}</span>
                </div>
                <div class="d-flex">
                    <div
                        class="px-2"
                        *ngIf="state?.mirrorCopyAlertInfo.isOriginalCommitment"
                    >
                        <button
                            class="cmps-outline-button--sm cmps-outline-button--no-bg"
                            cmpsOutlineButton
                            (click)="_onGoToDraftClick()"
                        >
                            <span cmpsOutlineButtonLabel>
                                {{
                                    _i18n._9804_GO_TO_DRAFT_COMMITMENT
                                        | translate
                                }}
                            </span>
                        </button>
                    </div>
                    <div
                        class="px-2"
                        *ngIf="
                            state?.mirrorCopyAlertInfo.isOriginalCommitment ===
                            false
                        "
                    >
                        <button
                            class="cmps-outline-button--sm cmps-outline-button--no-bg"
                            cmpsOutlineButton
                            (click)="_onGoToCommitmentClick()"
                        >
                            <span cmpsOutlineButtonLabel>{{
                                _i18n._9805_GO_TO_ACTIVE_COMMITMENT | translate
                            }}</span>
                        </button>
                    </div>
                </div>
            </div>
        </cmps-alert>

        <div class="container px-4">
            <div
                class="row"
                data-e2e="area-messages"
            >
                <!--TODO create something more elaborate //-->
                <div
                    class="col-12 notification px-0"
                    (click)="_onDismissMessageClick()"
                    *ngIf="state?.justSaved"
                >
                    <h6 class="alert notification-success text-left">
                        {{ _i18n._9499_THE_COMMITMENT_WAS_SAVED_ | translate }}
                    </h6>
                </div>
                <div
                    class="d-inline-flex align-items-center flex-grow-1 alert-warning-compas"
                    data-e2e="alert-start-time"
                    *ngIf="_form.errors['DATE']"
                >
                    <cmps-icon svgIcon="alert"></cmps-icon>
                    <div class="h6 m-0 ml-2 text-white">
                        {{ _form.errors['DATE'] }}
                    </div>
                </div>
                <div
                    class="d-inline-flex align-items-center flex-grow-1 alert-warning-compas"
                    *ngIf="_form.errors['FOCUS']"
                >
                    <cmps-icon svgIcon="alert"></cmps-icon>
                    <div class="h6 m-0 ml-2 text-white">
                        {{ _form.errors['FOCUS'] }}
                    </div>
                </div>
            </div>

            <div class="row mb-2">
                <div class="col pl-0 text-left">
                    <div
                        class="h4 mb-0"
                        role="heading"
                    >
                        <span>{{ state?.statusName | translate }}</span>
                        <span *ngIf="state?.subStatusName">
                            <!--don't line break this span-->
                            ({{ state?.subStatusName | translate
                            }}<span *ngIf="state?.subStatusMessage"
                                >&nbsp;{{ state?.subStatusMessage }}</span
                            >)
                        </span>
                    </div>
                </div>
                <div class="col pr-0 text-right">
                    <div
                        class="col flex-buttons-container flex-controls justify-content-end pr-0 cmps-commitment--action-buttons"
                    >
                        <cmps-wait-status *ngIf="_pending"></cmps-wait-status>
                        <button
                            class="cmps-button--no-bg"
                            cmpsButton
                            [cmpsTooltipTrigger]="
                                _i18n._9993_START_TEAMS_CALL | translate
                            "
                            trigger="hover"
                            [disabled]="
                                _selectedUser == null ||
                                (state?.commitment?.statusId !==
                                    _CoachingEventStatus.DRAFT &&
                                    state?.commitment?.statusId !==
                                        _CoachingEventStatus.ACTIVE)
                            "
                            (click)="_onCallClick()"
                            *ngIf="state?.enabledActions?.teamsCallCanStartCall"
                        >
                            <cmps-icon svgIcon="phone-in-talk"></cmps-icon>
                            <span cmpsButtonLabel>{{
                                _i18n._5101_CALL | translate
                            }}</span>
                        </button>
                        <button
                            class="cmps-button--no-bg"
                            cmpsButton
                            [cmpsTooltipTrigger]="
                                state?.enabledActions?.teamsCallCanStartChat
                                    ? (_i18n._11121_START_TEAMS_CHAT
                                      | translate)
                                    : (_i18n._11123_A_CHAT_CANNOT_BE_STARTED_ON_AN_UNSAVED_COMMITMENT
                                      | translate)
                            "
                            trigger="hover"
                            [disabled]="
                                !state?.enabledActions?.teamsCallCanStartChat
                            "
                            (click)="_onChatClick()"
                            *ngIf="state?.enabledActions?.teamsCallHasChat"
                        >
                            <cmps-icon svgIcon="chat"></cmps-icon>
                            <span cmpsButtonLabel>{{
                                _i18n._11041_CHAT | translate
                            }}</span>
                        </button>
                        <button
                            class="cmps-button--no-bg"
                            cmpsButton
                            [disabled]="_pending"
                            (click)="_onApproveClick()"
                            *ngIf="state?.approvalAlertInfo?.showButtons"
                        >
                            <cmps-icon svgIcon="thumb-up"></cmps-icon>
                            <span cmpsButtonLabel>{{
                                _i18n._9471_APPROVE | translate
                            }}</span>
                        </button>
                        <button
                            class="cmps-button--no-bg"
                            cmpsButton
                            [disabled]="_pending"
                            (click)="_onDisputeClick()"
                            *ngIf="state?.approvalAlertInfo?.showButtons"
                        >
                            <cmps-icon svgIcon="thumb-down"></cmps-icon>
                            <span cmpsButtonLabel>{{
                                _i18n._9472_DISPUTE | translate
                            }}</span>
                        </button>
                        <button
                            class="cmps-button--no-bg"
                            cmpsButton
                            [disabled]="
                                !state?.enabledActions?.delete || _pending
                            "
                            data-e2e="button-delete"
                            (click)="_onDeleteClick()"
                        >
                            <cmps-icon svgIcon="delete"></cmps-icon>
                            <span cmpsButtonLabel>{{
                                _i18n._7424_DELETE | translate
                            }}</span>
                        </button>
                        <!--TODO revise. save button used to have !_dirty check on the disabled attr-->
                        <button
                            class="cmps-button--no-bg"
                            cmpsButton
                            [disabled]="
                                !state?.enabledActions?.save || _pending
                            "
                            data-e2e="button-save"
                            (click)="_onSaveClick()"
                        >
                            <cmps-icon svgIcon="content-save"></cmps-icon>
                            <span cmpsButtonLabel>{{
                                _i18n._9416_SAVE_DRAFT | translate
                            }}</span>
                        </button>
                        <button
                            class="cmps-button--no-bg"
                            cmpsButton
                            [disabled]="
                                !state?.enabledActions?.close || _pending
                            "
                            (click)="_onCloseClick()"
                        >
                            <cmps-icon svgIcon="close"></cmps-icon>
                            <span cmpsButtonLabel>{{
                                _i18n._9754_COMPLETE | translate
                            }}</span>
                        </button>
                        <button
                            class="cmps-button--no-bg"
                            cmpsButton
                            [disabled]="
                                state?.editingIntended ||
                                !state?.enabledActions?.edit
                            "
                            (click)="_onEditClick()"
                        >
                            <cmps-icon svgIcon="pencil"></cmps-icon>
                            <span cmpsButtonLabel>{{
                                _i18n._7425_EDIT | translate
                            }}</span>
                        </button>

                        <!--TODO revise. publish button used to have !_dirty check on the disabled attr-->
                        <button
                            class="cmps-button--no-bg"
                            cmpsButton
                            [disabled]="!state?.enabledActions?.publish"
                            (click)="_onPublishClick()"
                        >
                            <cmps-icon svgIcon="coaching:publish"></cmps-icon>
                            <span cmpsButtonLabel>{{
                                _i18n._9415_PUBLISH | translate
                            }}</span>
                        </button>
                        <button
                            class="pl-5 cmps-icon-button--no-bg"
                            cmpsIconButton
                            (click)="_onCloseToDetailClick()"
                        >
                            <cmps-icon svgIcon="close"></cmps-icon>
                        </button>
                    </div>
                </div>
            </div>
        </div>
        <hr class="m-0 w-100" />

        <div class="container-scroll pt-3">
            <div class="container">
                <div class="row">
                    <div class="col px-0">
                        <label>
                            <span
                                >{{
                                    _i18n._9486_CREATOR_ | translate
                                }}&nbsp;</span
                            >
                            <span>{{ state?.creatorName }}</span>
                        </label>
                    </div>
                </div>
                <div class="row">
                    <div class="col-3 pl-0">
                        <label
                            class="labelBold text-left label-title"
                            [class.ct-focus-header-active]="
                                state?.tagInfo?.behaviour?.id != null
                            "
                        >
                            {{ _i18n._9424_COMMITMENT_FOCUS | translate }}
                        </label>
                    </div>
                    <div class="col pl-0">
                        <div class="row justify-content-end date-time-inputs">
                            <div class="d-inline-flex align-items-center">
                                <ng-container
                                    *ngIf="
                                        state?.commitment?.statusId !==
                                        _CoachingEventStatus.DRAFT
                                    "
                                >
                                    <div>
                                        {{
                                            _i18n._9419_TYPE_ | translate
                                        }}&nbsp;
                                    </div>
                                    <!--TODO simplify this-->
                                    <ng-container
                                        *ngFor="let option of _deliveryTypeOpts"
                                    >
                                        <div
                                            *ngIf="
                                                option.value ===
                                                _form.form.controls[
                                                    _form.fields.DELIVERY_TYPE
                                                        .name
                                                ].value
                                            "
                                        >
                                            {{ option.label }}
                                        </div>
                                    </ng-container>
                                </ng-container>
                                <ng-container
                                    *ngIf="
                                        state?.commitment?.statusId ===
                                        _CoachingEventStatus.DRAFT
                                    "
                                >
                                    <div>
                                        {{ _i18n._76_TYPE | translate }}&nbsp;
                                    </div>
                                    <ng-select
                                        class="ng-select--variant-1"
                                        [options]="_deliveryTypeOpts"
                                        [noFilter]="999"
                                        [ariaLabel]="_i18n._76_TYPE | translate"
                                        [formControlName]="
                                            _form.fields.DELIVERY_TYPE.name
                                        "
                                    ></ng-select>
                                </ng-container>
                            </div>
                            <div
                                class="text-right p-0 d-flex justify-content-end align-items-center"
                            >
                                <div class="days-active">
                                    {{ _i18n._9473_DAYS_ACTIVE | translate }}:
                                    {{ state?.activeDays }}
                                </div>
                            </div>
                            <div
                                class="d-inline-flex align-items-center pl-3"
                                *ngIf="
                                    state?.commitment?.statusId !==
                                    _CoachingEventStatus.DRAFT
                                "
                            >
                                <span
                                    >{{
                                        _i18n._9774_START_DATE_ | translate
                                    }}&nbsp;</span
                                >
                                <span>{{
                                    state?.commitment?.activeDate ||
                                        state?.commitment?.startDate
                                        | cmpsDate: 'LLL-dd-yyyy'
                                }}</span>
                            </div>
                            <div
                                class="input-group start-date-group col-3 pr-0"
                                *ngIf="
                                    state?.commitment?.statusId ===
                                    _CoachingEventStatus.DRAFT
                                "
                            >
                                <label class="text-left col-form-label">
                                    {{ _i18n._75_START_DATE | translate }}
                                </label>
                                <input
                                    class="form-control commitment-date"
                                    [maxDate]="_maxDateStruct"
                                    [minDate]="_minDateStruct"
                                    aria-labelledby="commitmentDate-label"
                                    ngbDatepicker
                                    [formControlName]="_form.fields.DATE.name"
                                    #dp="ngbDatepicker"
                                />
                                <div class="input-group-append">
                                    <button
                                        type="button"
                                        class="btn btn-secondary date-selector-btn"
                                        aria-label="Toggle date picker"
                                        [attr.aria-expanded]="dp.isOpen()"
                                        (click)="dp.toggle()"
                                    >
                                        <cmps-icon
                                            class="formIcon"
                                            svgIcon="calendar-range"
                                        ></cmps-icon>
                                    </button>
                                </div>
                            </div>
                            <div class="pl-2 input-group-time-container">
                                <label class="col-form-label">{{
                                    _i18n._9469_SESSION_TIME | translate
                                }}</label>
                                <div class="input-group-time">
                                    <div
                                        cmpsEditableTimer
                                        (change)="_onTimerChange()"
                                        [formControlName]="
                                            _form.fields.DURATION.name
                                        "
                                    ></div>
                                </div>
                            </div>
                            <div class="pl-2 input-group-time-container">
                                <label class="col-form-label">{{
                                    _i18n._9470_TOTAL_TIME | translate
                                }}</label>
                                <div class="input-group-time">
                                    <div class="total-time">
                                        {{ state?.totalTimeStr }}
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
                <div class="row pb-2">
                    <div
                        class="ct-focus"
                        role="button"
                        tabindex="0"
                        [class.ct-focus-active]="state?.tagInfo?.behaviour?.id"
                        [class.ct-focus-disabled]="
                            _form?.form.value?.observations.length > 0 ||
                            state?.commitment?.statusId !==
                                _CoachingEventStatus.DRAFT ||
                            !_form?.form?.enabled
                        "
                        (click)="_onFocusClick(trigger, triggerNext)"
                        (keyup.space)="_onFocusClick(trigger, triggerNext)"
                        (keyup.enter)="_onFocusClick(trigger, triggerNext)"
                    >
                        <div class="ct-focus-behaviour">
                            <span class="ct-focus-label"
                                >{{
                                    _i18n._9422_BEHAVIOUR_ | translate
                                }}&nbsp;</span
                            >
                            <div class="ct-focus-text">
                                {{
                                    state?.tagInfo?.behaviour?.id
                                        ? state?.tagInfo?.behaviour?.name
                                        : (_i18n._9777_CLICK_HERE_TO_SET_THE_FOCUS_FOR_THIS_COMMITMENT
                                          | translate)
                                }}
                            </div>
                        </div>
                        <div class="ct-focus-sub-behaviour">
                            <span class="ct-focus-label"
                                >{{
                                    _i18n._9423_SUB_BEHAVIOUR_ | translate
                                }}&nbsp;</span
                            >
                            <div class="ct-focus-text">
                                {{
                                    state?.tagInfo?.subBehaviour?.id
                                        ? state?.tagInfo?.subBehaviour?.name
                                        : (_i18n._9777_CLICK_HERE_TO_SET_THE_FOCUS_FOR_THIS_COMMITMENT
                                          | translate)
                                }}
                            </div>
                            <cmps-coaching-bl-button
                                [focus]="state?.tagInfo?.focus"
                            ></cmps-coaching-bl-button>
                        </div>
                        <cmps-tag-set-trigger
                            storePathPrefix="coachingCommitment"
                            [mode]="_TagSetMode.FOCUS_ONLY"
                            [focusSelectionParams]="
                                state?.coachingEvent?.focusSelectionParams
                            "
                            [performerId]="state?.performer?.id"
                            [activeMetricId]="
                                _isGeneric ? null : _activeMetricId
                            "
                            [formControlName]="_form.fields.FOCUS.name"
                            #trigger
                        ></cmps-tag-set-trigger>
                        <cmps-focus-selector-trigger
                            storePathPrefix="coachingCommitment"
                            [performerId]="state?.performer?.id"
                            [activeMetricId]="
                                _isGeneric ? null : _activeMetricId
                            "
                            [goalsCollection]="
                                _form?.form?.controls?.[
                                    _form?.fields?.GOALS_COLLECTION?.name
                                ]
                            "
                            [formControlName]="_form.fields.FOCUS.name"
                            [triggerSource]="
                                _FocusSelectorTriggerSource.COMMITMENT
                            "
                            #triggerNext
                        ></cmps-focus-selector-trigger>
                    </div>
                </div>
                <div class="row evaluations-lastupdated-container">
                    <div class="col-12 pl-0 pr-0">
                        <div class="row d-flex p-0 m-0 justify-content-end">
                            <div class="evaluations-container pl-0 col-9">
                                <cmps-observation-focus-summary
                                    storePathPrefix="coachingCommitment"
                                    mode="commitment"
                                    [published]="true"
                                    [performerId]="state?.performer?.id"
                                    [interactionEntity]="
                                        state?.interactionEntity
                                    "
                                    [focus]="state?.tagInfo?.focus"
                                    [hideSubSummary]="true"
                                    [commitmentObservations]="
                                        _form?.value?.observations
                                    "
                                    *ngIf="
                                        _form?.value?.observations?.length > 0
                                    "
                                ></cmps-observation-focus-summary>
                            </div>
                            <div class="latest-update-container col-3 pr-0">
                                <div class="col-12 p-0">
                                    <h6>
                                        {{
                                            _i18n._7313_LAST_UPDATED_
                                                | translate
                                        }}
                                    </h6>
                                </div>
                                <div class="col-12 mb-1 pr-0">
                                    <div class="row">
                                        <div
                                            class="col-12 pl-0 d-flex align-items-center"
                                            *ngIf="
                                                !state?.commitment
                                                    ?.timelineLatestUpdate
                                                    ?.latestUpdate
                                            "
                                        >
                                            <span>{{
                                                _i18n._9460_NO_UPDATES_YET
                                                    | translate
                                            }}</span>
                                        </div>
                                        <div
                                            class="col-6 pl-0 d-flex align-items-center"
                                            *ngIf="
                                                state?.commitment
                                                    ?.timelineLatestUpdate
                                                    ?.latestUpdate
                                            "
                                        >
                                            <span>{{
                                                state?.commitment
                                                    ?.timelineLatestUpdate
                                                    ?.latestUpdate?.events
                                            }}</span>
                                        </div>
                                        <div
                                            class="col-6 pl-0 d-flex align-items-center justify-content-end"
                                            *ngIf="
                                                state?.commitment
                                                    ?.timelineLatestUpdate
                                                    ?.latestUpdate
                                            "
                                        >
                                            <div
                                                class="latest-update d-flex align-items-center"
                                            >
                                                <span
                                                    >{{
                                                        state?.commitment
                                                            ?.timelineLatestUpdate
                                                            ?.latestUpdate?.date
                                                            | cmpsDate
                                                                : 'LLL-dd-yyyy'
                                                    }}
                                                </span>
                                                <cmps-icon
                                                    svgIcon="calendar-range"
                                                    class="text-muted"
                                                ></cmps-icon>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>

            <hr class="mb-0 w-100" />

            <div class="container p-1">
                <div class="row">
                    <div class="col mb-3">
                        <cmps-commitment-narrative
                            [noteEntity]="state?.noteEntity"
                            [formControlName]="_form.fields.NOTES.name"
                        ></cmps-commitment-narrative>
                    </div>
                </div>
                <div class="row">
                    <div class="col mb-3">
                        <div
                            cmpsCommitmentObservations
                            [focus]="_form?.value?.focus"
                            [draftCommitmentId]="state?.draftId || _draftId"
                            [commitmentId]="
                                state?.commitment?.commitmentId || _commitmentId
                            "
                            [linkDisabled]="
                                !this._form.form.controls[
                                    _form.fields.FOCUS.name
                                ].valid
                            "
                            [formControlName]="_form.fields.OBSERVATIONS.name"
                        ></div>
                    </div>
                </div>
                <div class="row">
                    <div class="col mb-3">
                        <div
                            cmpsCommitmentGoals
                            storePathPrefix="coachingCommitment"
                            [focus]="_form?.value?.focus"
                            [commitmentId]="
                                _commitmentId || state?.commitment?.commitmentId
                            "
                            [draftId]="_draftId || state?.commitment?.draftId"
                            [performerId]="state?.performer?.id"
                            [linkedObservations]="_form?.value?.observations"
                            [lastLinkedObservation]="_lastLinkedObservation"
                            (onGoalCloseClick)="onGoalCloseClick($event)"
                            (manageGoal)="_onManageGoal()"
                            [goalId]="_goalId"
                            [isGeneric]="_isGeneric"
                            [goalThresholds]="
                                state?.coachingEvent?.goalThresholds
                            "
                            [approval]="
                                state?.draft?.approval ||
                                state?.draft?.previousApproval ||
                                state?.approval
                            "
                            [activeMetricId]="_activeMetricId"
                            [placeholderMetrics]="
                                state?.commitment?.placeholderMetrics
                            "
                            [focusSelectionParams]="
                                state?.coachingEvent?.focusSelectionParams
                            "
                            [newFocusSelectorWithYield]="
                                state?.coachingEvent?.newFocusSelectorWithYield
                            "
                            [formControlName]="
                                _form.fields.GOALS_COLLECTION.name
                            "
                        ></div>
                    </div>
                </div>
            </div>
        </div>
    </ng-container>
</div>
